import { GET_INFO, GET_USER, GET_TOKEN, GET_LOADERS, GET_USER_LIST, GET_CONVERSION_CURRENCY, GET_QUESTIONS,GET_MANAGER_LIST_DATA,GET_COUNTRIES_FOR_CLIENT, GET_HELP2PAY_BANK_LIST, GET_VERTUPAY_BANK_LIST} from '../types'

export const getters = {
  // return the latest broadcast message
  [GET_INFO] (state) {
    return state.message
  },
  // return the current user statecurrencyList
  [GET_USER] (state) {
    return state.user
  },
  // return the token from local storage
  [GET_TOKEN] (state) {
    return state.user.token
  },
  
  // return the token from local storage
  [GET_CONVERSION_CURRENCY] (state) {
    return state.convertedCurrencies
  },
  // all loaders
  [GET_LOADERS] (state) {
    return state.loaders
  },
  [GET_QUESTIONS] (state) {
    return state.questions
  },
  [GET_COUNTRIES_FOR_CLIENT] (state) {
    return state.countriesJsonForClient
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js